var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonComponent',{staticClass:"my-4",attrs:{"buttonSize":"small","buttonStyle":"white","iconLeft":"chevron-left"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Back ")])
}
var staticRenderFns = []

export { render, staticRenderFns }